// extracted by mini-css-extract-plugin
export var image = "style-module--image--3de89";
export var included = "style-module--included--e3f47";
export var left = "style-module--left--9a471";
export var product = "style-module--product--de62c";
export var right = "style-module--right--8299c";
export var sku = "style-module--sku--abdb0";
export var summaryBox = "style-module--summaryBox--f7543";
export var title = "style-module--title--6f7af";
export var total = "style-module--total--16e3e";